<template>
  <div class="mt-4">
    <Title title="FICHA_SAUDE.DEFICIENCIAS" />
    <b-row>
      <b-col>
        <input-checkbox
          ref="fichaSaude.deficiencia"
          v-model="fichaSaude.deficiencia"
          class="mt-1"
          :label="$t('FICHA_SAUDE.DEFICIENCIAS_CONFIRMACAO')"
        />
        <input-text
          ref="fichaSaude.especificacaoDeficiencia"
          v-model="fichaSaude.especificacaoDeficiencia"
          :label="$t('FICHA_SAUDE.DEFICIENCIAS_ESPECIFIQUE')"
          :placeholder="$t('FICHA_SAUDE.DEFICIENCIAS_DESCRICAO_CID')"
        />
      </b-col>
      <b-col>
        <p>{{ $t("FICHA_SAUDE.DEFICIENCIAS_SELECIONE") }}</p>
        <b-row>
          <b-col>
            <input-checkbox
              ref="defFisica"
              v-model="defFisica"
              :label="$t('FICHA_SAUDE.DEFICIENCIA_FISICA')"
              @change="alteraDeficienciaFisica"
            />
            <input-checkbox
              v-model="defVisual"
              :label="$t('FICHA_SAUDE.DEFICIENCIA_VISUAL')"
              @change="alteraDeficienciaVisual"
            />
            <input-checkbox
              v-model="defAuditiva"
              :label="$t('FICHA_SAUDE.DEFICIENCIA_AUDITIVA')"
              @change="alteraDeficienciaAuditiva"
            />
          </b-col>
          <b-col>
            <input-checkbox
              v-model="defIntelectual"
              :label="$t('FICHA_SAUDE.DEFICIENCIA_INTELECTUAL')"
              @change="alteraDeficienciaIntelectual"
            />
            <input-checkbox
              v-model="defPsicossocial"
              :label="$t('FICHA_SAUDE.DEFICIENCIA_PSICOSSOCIAL')"
              @change="alteraDeficienciaPsicossocial"
            />
            <input-checkbox
              v-model="defMultipla"
              :label="$t('FICHA_SAUDE.DEFICIENCIA_MULTIPLA')"
              @change="alteraDeficienciaMultipla"
            />
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import Title from "@/components/Title.vue";
import InputCheckbox from "@/components/inputs/InputCheckbox.vue";
import InputText from "@/components/inputs/InputText.vue";
export default {
  props: [
    "fichaSaude",
    "keyDeficienciaFisica",
    "deficienciaFisica",
    "deficienciaVisual",
    "deficienciaAuditiva",
    "deficienciaIntelectual",
    "deficienciaPsicossocial",
    "deficienciaMultipla",
  ],
  components: {
    Title,
    InputCheckbox,
    InputText,
  },
  data() {
    return {
      defFisica: false,
      defVisual: false,
      defAuditiva: false,
      defIntelectual: false,
      defPsicossocial: false,
      defMultipla: false,
    };
  },
  watch: {
    deficienciaFisica(valor) {
      if (valor) this.defFisica = true;
    },
    deficienciaVisual(valor) {
      if (valor) this.defVisual = true;
    },
    deficienciaAuditiva(valor) {
      if (valor) this.defAuditiva = true;
    },
    deficienciaIntelectual(valor) {
      if (valor) this.defIntelectual = true;
    },
    deficienciaPsicossocial(valor) {
      if (valor) this.defPsicossocial = true;
    },
    deficienciaMultipla(valor) {
      if (valor) this.defMultipla = true;
    },
  },
  methods: {
    alteraDeficienciaFisica() {
      this.$emit("alteraDeficiencia", this.defFisica, "Fisica");
    },
    alteraDeficienciaVisual() {
      this.$emit("alteraDeficiencia", this.defVisual, "Visual");
    },
    alteraDeficienciaAuditiva() {
      this.$emit("alteraDeficiencia", this.defAuditiva, "Auditiva");
    },
    alteraDeficienciaIntelectual() {
      this.$emit("alteraDeficiencia", this.defIntelectual, "Intelectual");
    },
    alteraDeficienciaPsicossocial() {
      this.$emit("alteraDeficiencia", this.defPsicossocial, "Psicossocial");
    },
    alteraDeficienciaMultipla() {
      this.$emit("alteraDeficiencia", this.defMultipla, "Multipla");
    },
  },
};
</script>
